<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('tasks.title') + ' (' + this.active_status + ')'"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-menu transition="slide-y-transition" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="info" class="darken-2">
            <v-icon>fab fa-buromobelexperte</v-icon>
            <span class="cstm-v-btn-text d-none d-sm-inline">{{ active_status }}</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, i) in this.$dd_task_status()" :key="i" @click="status(item.key, true)">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <router-link :to="BACKEND_URL + '/tasks/create'" v-if="$can('task-create')">
        <action-button type="new" />
      </router-link>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="tasks"
            :items-per-page="tasks.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.instructor_id="{ item }">
              {{ item.instructor.fullname }}
            </template>

            <template v-slot:item.start_datetime="{ item }">
              {{ moment.utc(item.start_date).format(DATE_FORMAT) + " " + moment.utc(item.start_time, TIME_FORMAT).format(TIME_FORMAT) }}
            </template>

            <template v-slot:item.end_datetime="{ item }">
              {{ moment.utc(item.end_date).format(DATE_FORMAT) + " " + moment.utc(item.end_time, TIME_FORMAT).format(TIME_FORMAT) }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link :to="{ path: BACKEND_URL + '/tasks/edit/' + item.id, props: { id: item.id } }" v-if="$can('task-edit')">
                <action-button type="edit" :icon_only="true" small />
              </router-link>

              <action-button type="delete" :icon_only="true" @click="del(item.id)" v-if="$can('task-delete')" small />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "TasksList",

  data() {
    return {
      url: "",
      tasks: [],
      active_status: "",
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__taskListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["start_datetime"],
        sortDesc: [false]
      },
      search_params: {
        any: "",
        title: "",
        status: 1 // ACtive
      }
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("tasks.name"), value: "title" },
          { text: this.$t("tasks.instructor_id"), value: "instructor_id" },
          { text: this.$t("tasks.start_datetime"), value: "start_datetime" },
          { text: this.$t("tasks.end_datetime"), value: "end_datetime" },
          { text: this.$t("global.actions"), value: "actions", widht: "20%", align: "end", sortable: false }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__taskListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (
            _.has(newVal, "sortBy") &&
            _.has(newVal, "sortDesc") &&
            _.has(oldVal, "sortBy") &&
            _.has(oldVal, "sortDesc") &&
            (!_.isEqual(newVal.sortBy, oldVal.sortBy) || !_.isEqual(newVal.sortDesc, oldVal.sortDesc))
          ) {
            let obj = {
              sortBy: this.pagination.sortBy,
              sortDesc: this.pagination.sortDesc
            }
            localStorage.setItem("__taskListSort", JSON.stringify(obj))
          }

          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__taskListPage", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "tasks"
    if (localStorage.getItem("__taskListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__taskListSearchParams"))
    }
  },

  methods: {
    list() {
      this.show_loading = true

      let localSort = localStorage.getItem("__taskListSort")
      if (localSort !== null) {
        localSort = JSON.parse(localSort)
        this.pagination.sortBy = localSort.sortBy
        this.pagination.sortDesc = localSort.sortDesc
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      this.status(this.search_params.status)

      axios.get(this.url + "?" + query).then((res) => {
        this.tasks = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    status(key, must_refresh = false) {
      let text = this.$dd_task_status(key)

      if (text) {
        this.active_status = text
        this.search_params.status = key

        if (must_refresh) {
          this.refresh = true
        }
      }
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "task/" + id)
            .then((res) => {
              vm.refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    }
  }
}
</script>

<style scoped></style>
